/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandheldScanner = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10 19H8v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zm-6-3H8v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zm-6-3H8v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zm-.2-8A1.2 1.2 0 0 1 17 6.2v2.6a1.2 1.2 0 0 1-1.2 1.2H8.2A1.2 1.2 0 0 1 7 8.8V6.2A1.2 1.2 0 0 1 8.2 5zM9 8h6V7H9z" />
        <path d="M18.8 2A1.2 1.2 0 0 1 20 3.2v8.6c0 .594-.433 1.086-1 1.181V20.8a1.2 1.2 0 0 1-1.2 1.2H6.2A1.2 1.2 0 0 1 5 20.8v-7.82c-.567-.095-1-.587-1-1.181V3.2A1.2 1.2 0 0 1 5.2 2zM6 11.018A1.2 1.2 0 0 1 7 12.2V20h10v-7.8a1.2 1.2 0 0 1 1-1.182V4H6z" />
      </g>
    </g>
  </Icon>
);
export { SvgHandheldScanner as HandheldScanner };
